import { createFileRoute } from '@tanstack/react-router'

import { IntegrationsPage } from '#features/settings/integrations/integrations-page'

export const Route = createFileRoute('/_app/$workspace/settings/integrations/')(
  {
    head: () => ({
      meta: [
        {
          title: 'Integrations',
        },
      ],
    }),
    component: () => <IntegrationsPage />,
  },
)
